export default __webpack_public_path__ + "static/media/camera_poor_oa.d136d0ff.svg";